import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import axios from "axios";
import language from "../../language";
import { defineRoleCenterSite } from "../handleAccessRoles";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const fetchData = async (lng = "english", params) => {
  const {
    page,
    limit,
    name,
    type,
    id,
    q,
    code,
    bypassRoleRestriction = false,
  } = params || {};
  try {
    const user = await getStorage();
    const { centerRole } = await defineRoleCenterSite();

    // Determine if user is a donor
    const isDonor = user.role === "donor" || user.account_type === "donor";

    // Apply role restrictions unless:
    // 1. User is a donor (for appointment booking)
    // 2. Explicitly bypassed (for specific use cases)
    // 3. It's a dropdown type (for forms)
    const shouldApplyRoleRestriction =
      !isDonor && !bypassRoleRestriction && type !== "dropdown";

    // The landing page lists centres to visitors who have not logged in.
    // Without a token the full route now answers 403, so anonymous callers
    // use the public listing, which carries name, code and address only.
    const isAnonymous = !user?.token;

    const options = isAnonymous
      ? {
          method: "GET",
          url: `${API_URL}/bloodCenter/public`,
          params: {
            page: page,
            limit: limit,
            q: q && q !== "" ? q : undefined,
          },
        }
      : {
          method: "GET",
          url: `${API_URL}/bloodCenter`,
          params: {
            page: page,
            limit: limit,
            name,
            q: q && q !== "" ? q : undefined,
            code,
            ...(shouldApplyRoleRestriction && { id: id || centerRole }),
          },
        };

    const queryRes = await api(options);

    let { data, count, totalRecords } = queryRes.data;

    if (type === "dropdown") {
      const res = (
        queryRes?.data?.data ||
        queryRes?.data?.data ||
        queryRes.data
      ).map((el) => {
        return {
          ...el,
          label: el.code + " - " + el.name,
          value: el._id,
        };
      });

      return res;
    }

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", language[lng].unable_fetch_centers);
  }
};

export default fetchData;

export const deleteCenter = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const options = {
      method: "DELETE",
      url: `${API_URL}/bloodCenter`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_center);
  } catch (error) {
    toastMessage("error", language[lng].error_delete_center);
  }
};

export const fetchCenterCountSite = async (lng = "english", params) => {
  try {
// eslint-disable-next-line no-unused-vars
    const { centerRole } = await defineRoleCenterSite();
    const user = await getStorage();

    const options = {
      method: "GET",
      url: `${process.env.REACT_APP_BBMS_REPORT_API}/analytics/centerSite`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const { data } = await axios(options);
    console.log("fetch count center", data);

    return data;
  } catch (error) {
    toastMessage("error", error);
  }
};
